module.exports = __webpack_public_path__ + "img/co_bg3.d3ff29d6.png";